import { render } from "./MiniWizardManager.vue?vue&type=template&id=6a594f1d"
import script from "./MiniWizardManager.vue?vue&type=script&lang=js"
export * from "./MiniWizardManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__